module.exports = __webpack_public_path__ + "static/media/rlogo.d0def4d6.png";